export default __webpack_public_path__ + "static/hero_tappable-07909d4667345a2f1b2b400cbabc9c19.mp4";